export const base = {
  'nav.features': 'Features',
}
